.progress-container {
  width: 100%;
}

.progress-inset {
  border-radius: var(--border-radius-medium);
  width: 100%;
  background: #313236;
  display: flex;
  align-items: center;
}

.progress-bar {
  /* --progress-width comes from `percentage`. --progress-color is only set when
     a colour is passed, so the fallback below is the default. */
  width: var(--progress-width);
  height: 0.6rem;
  border-radius: 0.4rem;
  background-color: var(--progress-color, var(--color-secondary));
}
